import { useSyncExternalStore } from 'react';

// Whether the device says it is online (navigator.onLine, kept current by the online/offline
// events). «false» is reliable: no network at all. «true» only means some network, so a failed
// request while online is still said as a failure, not as «Sin conexión».
function subscribe(cb) {
  window.addEventListener('online', cb);
  window.addEventListener('offline', cb);
  return () => {
    window.removeEventListener('online', cb);
    window.removeEventListener('offline', cb);
  };
}

export function isOnline() {
  return typeof navigator === 'undefined' || navigator.onLine !== false;
}

export function useOnline() {
  return useSyncExternalStore(subscribe, isOnline, () => true);
}
